// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SimulateRainfallInput } from "./SimulateRainfallInput";
import {
  SimulateRainfallInputFromJSON,
  SimulateRainfallInputFromJSONTyped,
  SimulateRainfallInputToJSON,
  SimulateRainfallInputToJSONTyped,
} from "./SimulateRainfallInput";
import type { SimulateRainfallOutput } from "./SimulateRainfallOutput";
import {
  SimulateRainfallOutputFromJSON,
  SimulateRainfallOutputFromJSONTyped,
  SimulateRainfallOutputToJSON,
  SimulateRainfallOutputToJSONTyped,
} from "./SimulateRainfallOutput";

/**
 *
 * @export
 * @interface SimulateRainfallSchema
 */
export interface SimulateRainfallSchema {
  /**
   *
   */
  tag: SimulateRainfallSchemaTagEnum;
  /**
   *
   */
  inputs: SimulateRainfallInput;
  /**
   *
   */
  outputs: SimulateRainfallOutput;
}

/**
 * @export
 */
export const SimulateRainfallSchemaTagEnum = {
  SimulateRainfall: "simulate_rainfall",
} as const;
export type SimulateRainfallSchemaTagEnum =
  (typeof SimulateRainfallSchemaTagEnum)[keyof typeof SimulateRainfallSchemaTagEnum];

/**
 * Check if a given object implements the SimulateRainfallSchema interface.
 */
export function instanceOfSimulateRainfallSchema(value: object): value is SimulateRainfallSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "simulate_rainfall") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function SimulateRainfallSchemaFromJSON(json: any): SimulateRainfallSchema {
  return SimulateRainfallSchemaFromJSONTyped(json, false);
}

export function SimulateRainfallSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulateRainfallSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: SimulateRainfallInputFromJSON(json["inputs"]),
    outputs: SimulateRainfallOutputFromJSON(json["outputs"]),
  };
}

export function SimulateRainfallSchemaToJSON(json: any): SimulateRainfallSchema {
  return SimulateRainfallSchemaToJSONTyped(json, false);
}

export function SimulateRainfallSchemaToJSONTyped(
  value?: SimulateRainfallSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: SimulateRainfallInputToJSON(value["inputs"]),
    outputs: SimulateRainfallOutputToJSON(value["outputs"]),
  };
}
